import { useKrakenQuery } from '@/components/GraphQLClient';
import { useAuth } from '@/components/Providers/Auth';
import HasRestrictedAccess from '@/hooks/accounts/useHasRestrictedAccess/HasRestrictedAccess.graphql';
import { hasRestrictedAccessSchema } from '@/hooks/accounts/validations';
import { useSyncFeatureFlag } from '@/hooks/utils/useFeatureFlags';
import { FeatureNames } from '@/types/features';

type HasRestrictedAccess = {
  viewer: { hasRestrictedAccess?: boolean | null };
};

export const useHasRestrictedAccess = () => {
  const { isAuthenticated } = useAuth();

  const enabledBadDebtManagement = useSyncFeatureFlag(
    FeatureNames.BadDebtManagement
  );

  return useKrakenQuery({
    queryKey: ['hasRestrictedAccess'],
    query: HasRestrictedAccess,
    select: (data: HasRestrictedAccess) => data.viewer.hasRestrictedAccess,
    validateFn(response) {
      return hasRestrictedAccessSchema.validate(response);
    },
    enabled: Boolean(isAuthenticated && enabledBadDebtManagement),
  });
};
